import { TableBody, TableCell, TableHead, TableRow } from "~/common/components/Table/TableElements";
import { useTranslation } from "react-i18next";
import { NumberFormatter } from "~/common/utils/NumberFormatter";
import { SaleTag } from "~/domains/salesCampaign/components/SaleTag/SaleTag";
import { SalesTableTagSpan, StockTableStyled } from "./styled";

export type StockEntry = {
  quantity: number;
  date: string;
  sale?: true;
  soldOut?: true;
};

type StockTableProps = {
  warehouseName: string;
  stock: StockEntry[];
};

export const StockTable = ({ warehouseName, stock }: StockTableProps) => {
  const { t } = useTranslation();
  return (
    <StockTableStyled>
      <TableHead>
        <TableRow>
          <TableCell>{t("productDetailsPage.availabilityTable.units")}</TableCell>
          <TableCell>
            {window.SCHA.config.showESD
              ? warehouseName
              : t("productDetailsPage.availabilityTable.estimatedArrivalDate")}
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {stock.map((entry, index) => (
          <TableRow key={index}>
            <TableCell>{NumberFormatter.getDefaultFormatter().format(entry.quantity)}</TableCell>
            <TableCell>
              <span>{entry.date}</span>
              {entry.sale && (
                <SalesTableTagSpan>
                  {t("feature.salesCampaign.specialDealPrice")}
                  <SaleTag
                    className={"scha__pkg-selection__table__sales-tag"}
                    size={20}
                    variant={entry.soldOut ? "inactive" : "active"}
                  />
                </SalesTableTagSpan>
              )}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </StockTableStyled>
  );
};
